import { ModelBasic, NullTime } from '../core';

export const SystemRoutePermission = {
  NONE: 0,
  READ: 1,
  WRITE: 2,
  DELETE: 4,
};

export interface AuthAccount extends ModelBasic {
  username: string;
  email: string;
  password: string;
  password_repeat: string;
  access_token: string;
  is_active: boolean;
  first_name: string;
  last_name: string;
  is_password_expired: boolean;
  is_sysadmin: boolean;
  is_connected: boolean;
  theme: string;
  user_roles: AuthRole[];
  additional_data: AuthAccountAdditionalData[];
}
export interface AuthAccountAdditionalData extends ModelBasic {
  data_key: string;
  data_value: string;
}
export interface AuthAccountSession extends ModelBasic {
  account: AuthAccount;
  access_token: string;
  refresh_token: string;
  login_time: NullTime;
}

export interface AuthAccountRole extends ModelBasic {
  role: AuthRole;
  valid_from: string;
  valid_to: string;
}

export interface AuthRole extends ModelBasic {
  role_name: string;
  role_descrption: string;
  valid_from: string;
  valid_to: string;
  modules: AuthRoleModule[];
}

export interface AuthRoleModule extends ModelBasic {
  module: AuthModule;
  permission_groups: AuthRoleModulePermissionGroup[];
  valid_from: string;
  valid_to: string;
  permission: number;
  has_access: boolean;
}

export interface AuthRoleModulePermissionGroup extends ModelBasic {
  permission_group: AuthPermissionGroup;
  valid_from: string;
  valid_to: string;
  permission: number;
  sub_permission_groups: AuthRoleModulePermissionGroup[];
}

export interface AuthModule extends ModelBasic {
  module_name: string;
  module_key: string;
  description: string;
  icon: string;
  permission_groups: AuthPermissionGroup[];
}

export interface AuthPermissionGroup extends ModelBasic {
  permission_key: string;
  permission_name: string;
  possible_permissions: number; // BITSHIFT
  foreign_type: string;
  extra_check_type: string; // zB type ROUTE, PARAM; name billing_type
  extra_check_key: string;
  extra_check_value: string;
  // ExtraChecks als Array
  sub_permission_groups: AuthPermissionGroup[];
}
